import brandLogo from '../assets/My logo.png'

interface LogoProps {
  className?: string
  showText?: boolean
}

export function Logo({ className = "", showText = true }: LogoProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: 'transparent',
        background: 'none',
        border: 'none',
        boxShadow: 'none'
      }}
    >
      {/* Bubble Icon */}
      <img
        src={brandLogo}
        alt="The Caption Studio"
        className="logo-img"
        style={{
          height: '36px',
          width: 'auto',
          display: 'block',
          flexShrink: 0,
          objectFit: 'contain',
          backgroundColor: 'transparent',
          border: 'none',
          boxShadow: 'none'
        }}
      />

      {/* 3-line text block */}
      {showText && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'center',
          lineHeight: 1.1
        }}>
          <span style={{
            fontFamily: "'Space Grotesk', 'Inter', sans-serif",
            fontWeight: 200,
            fontSize: '10px',
            textTransform: 'uppercase',
            color: '#D1D1F7',
            letterSpacing: '2px',
            lineHeight: 1.1,
            display: 'block'
          }}>The</span>

          <span style={{
            fontFamily: "'Space Grotesk', 'Inter', sans-serif",
            fontWeight: 800,
            fontSize: '18px',
            color: '#FFFFFF',
            letterSpacing: '-0.01em',
            lineHeight: 1.1,
            display: 'block'
          }}>Caption</span>

          <span style={{
            fontFamily: "'Space Grotesk', 'Inter', sans-serif",
            fontWeight: 500,
            fontSize: '11px',
            textTransform: 'uppercase',
            color: '#8E8FFA',
            letterSpacing: '3px',
            lineHeight: 1.1,
            display: 'block'
          }}>Studio</span>
        </div>
      )}
    </div>
  )
}
